import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } })?.response?.status ?? 0
        return status >= 500 && failureCount < 2
      },
      staleTime: 30_000,
    },
  },
})
